import { render, staticRenderFns } from "./PgaAreaManagersTable.vue?vue&type=template&id=522e897c&"
import script from "./PgaAreaManagersTable.vue?vue&type=script&lang=ts&"
export * from "./PgaAreaManagersTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('522e897c')) {
      api.createRecord('522e897c', component.options)
    } else {
      api.reload('522e897c', component.options)
    }
    module.hot.accept("./PgaAreaManagersTable.vue?vue&type=template&id=522e897c&", function () {
      api.rerender('522e897c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/AreaManagers/Components/PgaAreaManagersTable.vue"
export default component.exports